import {
  ENUM_COLUMN_TYPE,
  ENUM_BLANK_IF_NOT_MAPPED_SUB_TYPE,
} from "../types/constants";

/** Builds a column -> internalName -> displayName lookup from the given options field. */
export const buildEnumLookup = (columnsData, optionsField) => {
  const lookup = {};
  (columnsData ?? []).forEach((col) => {
    if (!col[optionsField]) return;
    const columnLookup = {};
    col[optionsField].forEach(({ internalName, displayName }) => {
      columnLookup[internalName] = displayName;
    });
    lookup[col.column] = columnLookup;
  });
  return lookup;
};

/** Returns names of enum columns whose sub-type blanks unmapped values, read from the given fields. */
export const blankIfNotMappedColumns = (columnsData, typeField, subTypeField) =>
  (columnsData ?? [])
    .filter(
      (col) =>
        col[typeField] === ENUM_COLUMN_TYPE &&
        col[subTypeField] === ENUM_BLANK_IF_NOT_MAPPED_SUB_TYPE
    )
    .map((col) => col.column);

/** Resolves an enum internal value to its display value. */
export const resolveEnumDisplayValue = (
  lookup,
  blankColumns,
  columnName,
  internalValue
) => {
  const defVal = blankColumns.includes(columnName) ? "" : internalValue;
  return lookup[columnName]?.[internalValue] ?? defVal ?? "";
};
